import * as React from 'react';

import InputCheckbox from 'components/inputs/input-checkbox/InputCheckbox';

import { DESCRIPTION, HASHTAG, TITLE } from '../../queries/sov-queries';

import type { SortableTableColumn } from 'types';
import type { SOVQueryColumnTitleCallback, SOVQueryEndpoint } from 'modules/insights/sov/types';
import type {
  SOVQueryColumnContentsCallback,
  SOVQueryToggleCallback
} from 'modules/insights/sov/types/youtube';

export const getColumnCheckbox = (toggleCallback: SOVQueryToggleCallback, className?: string): SortableTableColumn => ({
  key: 'sov-table-column--checkbox',
  title: '',
  className,

  render: (query: SOVQueryEndpoint) => (
    <InputCheckbox
      key={`sov-table-column__checkbox-${String(query.id)}`}
      id={`sov-table-column__checkbox-${String(query.id)}`}
      name="enabled"
      value={String(query.enabled)}
      checked={query.enabled}
      onChange={(event) => toggleCallback(event, query)}
    />
  )
});

export const getColumnHashtag = (
  columnTitleCallback: SOVQueryColumnTitleCallback,
  columnContentsCallback: SOVQueryColumnContentsCallback,
  className?: string
): SortableTableColumn => ({
  key: `sov-table-column--${HASHTAG}`,
  title: columnTitleCallback(HASHTAG),
  className,

  render: (query: SOVQueryEndpoint) => (
    columnContentsCallback(query, HASHTAG)
  )
});

export const getColumnVideoTitle = (
  columnTitleCallback: SOVQueryColumnTitleCallback,
  columnContentsCallback: SOVQueryColumnContentsCallback,
  className?: string
): SortableTableColumn => ({
  key: `sov-table-column--${TITLE}`,
  title: columnTitleCallback(TITLE),
  className,

  render: (query: SOVQueryEndpoint) => (
    columnContentsCallback(query, TITLE)
  )
});

export const getColumnVideoDescription = (
  columnTitleCallback: SOVQueryColumnTitleCallback,
  columnContentsCallback: SOVQueryColumnContentsCallback,
  className?: string
): SortableTableColumn => ({
  key: `sov-table-column--${DESCRIPTION}`,
  title: columnTitleCallback(DESCRIPTION),
  className,

  render: (query: SOVQueryEndpoint) => (
    columnContentsCallback(query, DESCRIPTION)
  )
});
